import { useCallback, useState, useEffect } from 'react'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Image from 'react-bootstrap/Image'
import Logo from '../../assets/Logo.png'

import { isSmallDevice } from '../../utils/deviceScreen'

function Login({ children, imageSrc, backgroundColor, title = 'Entrar' }) {
  const [isSmallWidth, setIsSmallWidth] = useState(() => {
    const checkScreenWidth = isSmallDevice()

    return checkScreenWidth
  })

  const updateShowMenu = useCallback(() => {
    const checkScreenWidth = isSmallDevice()
    setIsSmallWidth(checkScreenWidth)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateShowMenu)
    return () => {
      window.removeEventListener('resize', updateShowMenu)
    }
  })
  return (
    <>
      <Row>
        {!isSmallWidth ? (
          <Col>
            <Image style={{ maxHeight: '100%', maxWidth: '100%' }} src={imageSrc} />
          </Col>
        ) : null}

        <Col
          style={{
            marginTop: isSmallWidth ? '.1rem' : '10%',
            marginLeft: isSmallWidth ? '.1rem' : '100px',
            marginRight: isSmallWidth ? '.1rem' : '100px',
            textAlign: 'center',
          }}
        >
          <Image className="mt-4 mt-md-0" width={200} src={Logo} />
          <div
            style={{
              padding: '30px',
              paddingTop: '10px',
            }}
          >
            {children}
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Login
